import { GTMEventSearchModel } from '../../models';

export enum SearchEventNames {
  click = 'click_activate_constructor_search_main',
  clickSticky = 'click_activate_constructor_search_fixed',
  clickFastlinks = 'click_activate_constructor_search_fast_links_menu',
  clickListing = 'click_activate_constructor_search_listing',

  searchShowAll = 'click_view_all_constructor_search_main',
  searchShowAllSticky = 'click_view_all_constructor_search_fixed',

  searchEmpty = 'constructor_search_failure',

  searchReset = 'click_button_reset_constructor_search',
  clickShowAllByTitle = 'click_view_all_you_looking_for_constructor_search',

  search = 'constructor_search_main',
  searchSticky = 'constructor_search_fixed',
}

export enum SearchEventTypes {
  searchFilterEvents = 'search_filter_events',
}

export enum SearchEventCategories {
  search = 'Search',
}

export const getSearchEventName = (
  isSticky: boolean,
  isShowAll = false
): SearchEventNames => {
  switch (true) {
    case isShowAll: {
      return isSticky
        ? SearchEventNames.searchShowAllSticky
        : SearchEventNames.searchShowAll;
    }
    default: {
      return isSticky ? SearchEventNames.searchSticky : SearchEventNames.search;
    }
  }
};

export const getOpenSearchEventName = (isSticky: boolean): SearchEventNames => {
  return isSticky ? SearchEventNames.clickSticky : SearchEventNames.click;
};

export const getSearchEventData = (
  eventName: SearchEventNames,
  eventQuery?: string,
  eventParam?: string,
  eventQuantity?: number
): GTMEventSearchModel => {
  const event: GTMEventSearchModel = {
    event: eventName,
    event_type: SearchEventTypes.searchFilterEvents,
    event_category: SearchEventCategories.search,
    event_param: eventParam === eventQuery ? undefined : eventParam,
  };

  if (eventQuery) {
    event.event_query = eventQuery;
  }

  if (eventQuantity) {
    event.event_quantity = eventQuantity;
  }

  return event;
};
